import {
  ActionIcon,
  Menu,
  useComputedColorScheme,
  useMantineColorScheme,
} from "@mantine/core";
import {IconDeviceDesktop, IconMoon, IconSun} from "@tabler/icons-react";

export function ColorSchemeToggle() {
  const {setColorScheme} = useMantineColorScheme();

  const computedColorScheme = useComputedColorScheme("light", {
    getInitialValueInEffect: true,
  });

  return (
    <Menu shadow="md" width={160} position="bottom-end">
      <Menu.Target>
        <ActionIcon
          variant="subtle"
          color="teal"
          size="lg"
          aria-label="Toggle color scheme"
        >
          {computedColorScheme === "light" ? (
            <IconSun size={20} stroke={1.5} />
          ) : (
            <IconMoon size={20} stroke={1.5} />
          )}
        </ActionIcon>
      </Menu.Target>

      <Menu.Dropdown>
        <Menu.Label>Theme</Menu.Label>
        <Menu.Item
          leftSection={<IconSun size={16} stroke={1.5} />}
          onClick={() => setColorScheme("light")}
        >
          Light
        </Menu.Item>
        <Menu.Item
          leftSection={<IconMoon size={16} stroke={1.5} />}
          onClick={() => setColorScheme("dark")}
        >
          Dark
        </Menu.Item>
        <Menu.Item
          leftSection={<IconDeviceDesktop size={16} stroke={1.5} />}
          onClick={() => setColorScheme("auto")}
        >
          System
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}
